<template>
  <div class="s-car__programms">
    <div class="s-car__programms__body">
      <div class="s-car__programms__duration">
        <div class="title">{{ dictionary.numOfPaymentsLabel }}</div>
        <div class="options">
          <ul class="form-check-list">
            <li
              v-for="item in programmsYearsOptions"
              :key="idPrefix + item.years"
              class="form-check">
              <input
                :id="idPrefix + item.years"
                v-model="yearOption"
                class="form-check-input"
                type="radio"
                :name="'radio' + idPrefix"
                :value="item.years"
                @change="onChangeYearOption" />
              <label class="form-check-label" :for="idPrefix + item.years">
                {{ item.yearsText }}
              </label>
            </li>
          </ul>
        </div>
      </div>
      <div class="s-car__programms__payment-in-advance mb-24">
        <div
          v-if="displayPaymentInAdvanceToggle"
          class="form-check form-switch flex-row-reverse">
          <label
            class="form-check-label form-check-label--tooltip"
            :for="'paymentInAdvanced' + idPrefix"
            data-bs-toggle="tooltip"
            :title="dictionary.paymentInAdvanceTooltipText">
            <span>
              {{ dictionary.paymentInAdvanceToggleLabel }}
            </span>
            <LazyImage
              v-if="dictionary.paymentInAdvanceTooltipText"
              :image="{ url: '/imgs/icons/tooltip.svg' }"
              width="16" />
          </label>
          <input
            :id="'paymentInAdvanced' + idPrefix"
            v-model="withPrepaymentOwn"
            class="form-check-input"
            type="checkbox"
            role="switch"
            :checked="withPrepayment"
            @change="onChangeWithPrepayment" />
        </div>
      </div>
      <div class="s-car__programms__list mb-24">
        <div class="s-programms">
          <div class="s-programms__items">
            <div v-if="saverIncludesYearsOption" class="s-programms__item">
              <div class="b-programm saver">
                <div class="b-programm__body">
                  <h2 class="title">{{ dictionary.saverLabel }}</h2>
                  <ul class="prices">
                    <li>
                      <h5 class="years">
                        <span>{{ dictionary.yearsPrefix }}&nbsp;</span>
                        <span>
                          {{ saverObject.yearsText }}
                        </span>
                        <span>:</span>
                      </h5>
                      <div
                        class="b-leasing-car-config__price-w-vat"
                        :class="{ 'is-active': saverVatIncluded }">
                        <div class="bold mb-5">
                          <span class="animate">
                            <em v-if="saverVatIncluded">
                              {{ calculatedSaverPricePerMonthIncldVat }}
                            </em>
                            <em v-else>
                              {{ calculatedSaverPricePerMonth }}
                            </em>
                            <span class="suffix">
                              {{ dictionary.vehiclePriceSuffix }}
                            </span>
                          </span>
                        </div>

                        <div class="form-check form-switch">
                          <label
                            class="form-check-label"
                            :for="idPrefix + 'saverVat'"
                            :style="{
                              cursor: displaySaverVatToggle
                                ? 'pointer'
                                : 'default',
                            }">
                            <span v-if="saverVatIncluded">
                              {{ dictionary.vehicleVatIncluded }}
                            </span>
                            <span v-else>
                              {{ dictionary.vehicleVatExcluded }}
                            </span>
                          </label>
                          <input
                            v-if="displaySaverVatToggle"
                            :id="idPrefix + 'saverVat'"
                            v-model="saverVatIncluded"
                            class="form-check-input"
                            type="checkbox"
                            role="switch" />
                        </div>
                      </div>
                    </li>
                  </ul>

                  <div
                    ref="saverShowMoreButton"
                    class="learn-more-trigger d-flex d-md-none js-view-more"
                    @click="saverShowMore">
                    <span>{{ dictionary.buttonSeeMoreLabel }}</span>
                    <i></i>
                  </div>

                  <div ref="saverShowMoreBody" class="learn-more-body">
                    <hr />
                    <div v-if="saverKmPerYear > 0" class="kms-per-year">
                      <div class="title">
                        <div class="icon">
                          <img
                            src="https://hertz.gr/images/Leasing/icons/icon-km-per-year.svg" />
                        </div>
                        <span>{{ dictionary.kmPerYearLabel }}</span>
                      </div>
                      <div class="value">
                        {{ saverKmPerYear.toLocaleString(lang) }}
                      </div>
                      <hr />
                    </div>

                    <div class="payment-in-advanced">
                      <ul>
                        <li
                          v-if="withPrepayment && paymentInAdvanceInteger > 0">
                          <div class="title">
                            <div class="icon">
                              <img
                                src="https://hertz.gr/images/Leasing/icons/icon-payment-in-advanced.svg" />
                            </div>
                            <span>
                              {{ dictionary.paymentInAdvanceLabel }}
                              <span v-if="!saverVatIncluded">
                                <b>{{ paymentInAdvanceInteger }}€</b>
                                {{ dictionary.guaranteeVatExcluded }}
                              </span>
                              <span v-else>
                                <b>{{ paymentInAdvanceVatIncludedInteger }}€</b>
                                {{ dictionary.guaranteeVatIncluded }}
                              </span>
                            </span>
                          </div>
                        </li>
                        <li
                          v-if="saverGuarantee"
                          class="price-includes"
                          :class="{
                            'form-check-label form-check-label--tooltip':
                              saverGuaranteeTooltip,
                          }"
                          data-bs-toggle="tooltip"
                          :title="saverGuaranteeTooltip">
                          <div class="title">
                            <div class="icon">
                              <img
                                src="https://hertz.gr/images/Leasing/icons/icon-guarantee.svg" />
                            </div>
                            <span>{{ saverGuarantee }}&nbsp;&nbsp;</span>
                            <LazyImage
                              v-if="saverGuaranteeTooltip"
                              :image="{
                                url: '/imgs/icons/tooltip.svg',
                              }"
                              width="16" />
                          </div>
                        </li>
                      </ul>
                      <hr />
                    </div>

                    <div
                      v-if="saverPriceIncludes"
                      class="price-includes"
                      :class="{
                        'form-check-label form-check-label--tooltip':
                          saverPriceIncludes,
                      }"
                      data-bs-toggle="tooltip"
                      :title="saverPriceIncludes">
                      <div class="price-includes__body">
                        <div class="text">
                          {{ dictionary.priceIncludesLabel }} &nbsp;
                        </div>
                        <div class="icon">
                          <LazyImage
                            v-if="flexGuaranteeTooltip"
                            :image="{
                              url: '/imgs/icons/tooltip.svg',
                            }"
                            width="16" />
                        </div>
                      </div>
                    </div>

                    <div class="bottom">
                      <div class="attr-list">
                        <div class="attr-list__header">
                          <div class="title"><span>&nbsp;</span></div>
                        </div>
                        <div class="attr-list__body">
                          <div
                            v-for="item in computedLeaseSaverCharacteristics"
                            :key="item.id"
                            class="b-programm-attr"
                            data-bs-toggle="tooltip"
                            :title="item.tooltip">
                            <div v-if="item.image" class="icon">
                              <LazyImage :image="item.image" />
                            </div>

                            <div class="title">
                              {{ item.title }}
                            </div>
                            <LazyImage
                              v-if="item.tooltip"
                              :image="{
                                url: '/imgs/icons/tooltip.svg',
                              }"
                              width="16" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="contact">
                    <a
                      id="saver"
                      class="btn btn-primary"
                      :href="saverButtonUrl">
                      {{ dictionary.buttonContactUsText }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="flexIncludesYearsOption" class="s-programms__item">
              <div class="b-programm flex">
                <div class="b-programm__body">
                  <div v-if="flexBestValue" class="best-value">
                    <img
                      src="https://leasing-uat.hertz.gr/images/Leasing/misc/best-value.svg"
                      alt="" />
                  </div>
                  <h2 class="title">{{ dictionary.saverPlusLabel }}</h2>
                  <ul class="prices">
                    <li>
                      <h5 class="years">
                        <span>{{ dictionary.yearsPrefix }}&nbsp;</span>
                        <span>{{ flexObject.yearsText }}</span>
                        <span>:</span>
                      </h5>
                      <div
                        class="b-leasing-car-config__price-w-vat"
                        :class="{ 'is-active': flexVatIncluded }">
                        <div class="bold mb-5">
                          <span class="animate">
                            <em v-if="flexVatIncluded">
                              {{ calculatedFlexPricePerMonthIncldVat }}
                            </em>
                            <em v-else>
                              {{ calculatedFlexPricePerMonth }}
                            </em>
                            <span class="suffix">
                              {{ dictionary.vehiclePriceSuffix }}
                            </span>
                          </span>
                        </div>

                        <div class="form-check form-switch">
                          <label
                            class="form-check-label"
                            :style="{
                              cursor: displayFlexVatToggle
                                ? 'pointer'
                                : 'default',
                            }"
                            :for="idPrefix + 'flexVat'">
                            <span v-if="flexVatIncluded">
                              {{ dictionary.vehicleVatIncluded }}
                            </span>
                            <span v-else>
                              {{ dictionary.vehicleVatExcluded }}
                            </span>
                          </label>
                          <input
                            v-if="displayFlexVatToggle"
                            :id="idPrefix + 'flexVat'"
                            v-model="flexVatIncluded"
                            class="form-check-input"
                            type="checkbox"
                            role="switch" />
                        </div>
                      </div>
                    </li>
                  </ul>

                  <div
                    ref="flexShowMoreButton"
                    class="learn-more-trigger d-flex d-md-none"
                    @click="flexShowMore">
                    <span>{{ dictionary.buttonSeeMoreLabel }}</span>
                    <i></i>
                  </div>

                  <div ref="flexShowMoreBody" class="learn-more-body">
                    <hr />
                    <div v-if="flexKmPerYear > 0" class="kms-per-year">
                      <div class="title">
                        <div class="icon">
                          <img
                            src="https://hertz.gr/images/Leasing/icons/icon-km-per-year.svg" />
                        </div>
                        <span>{{ dictionary.kmPerYearLabel }}</span>
                      </div>
                      <div class="value">
                        {{ flexKmPerYear.toLocaleString(lang) }}
                      </div>
                      <hr />
                    </div>

                    <div class="payment-in-advanced">
                      <ul>
                        <li v-if="withPrepayment && paymentInAdvanceInteger">
                          <div class="title">
                            <div class="icon">
                              <img
                                src="https://hertz.gr/images/Leasing/icons/icon-payment-in-advanced.svg" />
                            </div>
                            <span>
                              {{ dictionary.paymentInAdvanceLabel }}
                              <span v-if="!flexVatIncluded">
                                <b>{{ paymentInAdvanceInteger }}€</b>
                                {{ dictionary.guaranteeVatExcluded }}
                              </span>
                              <span v-else>
                                <b>{{ paymentInAdvanceVatIncludedInteger }}€</b>
                                {{ dictionary.guaranteeVatIncluded }}
                              </span>
                            </span>
                          </div>
                        </li>
                        <li
                          v-if="flexGuarantee"
                          class="price-includes"
                          :class="{
                            'form-check-label form-check-label--tooltip':
                              flexGuaranteeTooltip,
                          }"
                          data-bs-toggle="tooltip"
                          :title="flexGuaranteeTooltip">
                          <div class="title">
                            <div class="icon">
                              <img
                                src="https://hertz.gr/images/Leasing/icons/icon-guarantee.svg" />
                            </div>
                            <span>{{ flexGuarantee }}&nbsp;&nbsp;</span>
                            <LazyImage
                              v-if="flexGuaranteeTooltip"
                              :image="{
                                url: '/imgs/icons/tooltip.svg',
                              }"
                              width="16" />
                          </div>
                        </li>
                      </ul>

                      <hr />
                    </div>

                    <div
                      v-if="flexPriceIncludes"
                      class="price-includes"
                      :class="{
                        'form-check-label form-check-label--tooltip':
                          flexPriceIncludes,
                      }"
                      data-bs-toggle="tooltip"
                      :title="flexPriceIncludes">
                      <div class="price-includes__body">
                        <div class="text">
                          {{ dictionary.priceIncludesLabel }} &nbsp;
                        </div>
                        <div class="icon">
                          <LazyImage
                            v-if="flexGuaranteeTooltip"
                            :image="{
                              url: '/imgs/icons/tooltip.svg',
                            }"
                            width="16" />
                        </div>
                      </div>
                    </div>

                    <div class="bottom">
                      <div class="attr-list">
                        <div class="attr-list__header">
                          <div class="title">
                            <strong>
                              {{ dictionary.benefitsLabel }}
                            </strong>
                          </div>
                        </div>
                        <div class="attr-list__body">
                          <div
                            v-for="item in computedLeaseFlexCharacteristics"
                            :key="item.id"
                            class="b-programm-attr"
                            data-bs-toggle="tooltip"
                            :title="item.tooltip">
                            <div v-if="item.image" class="icon">
                              <LazyImage :image="item.image" />
                            </div>
                            <div class="title">
                              {{ item.title }}
                            </div>
                            <LazyImage
                              v-if="item.tooltip"
                              :image="{
                                url: '/imgs/icons/tooltip.svg',
                              }"
                              width="16" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="contact">
                    <a id="flex" class="btn btn-primary" :href="flexButtonUrl">
                      {{ dictionary.buttonContactUsText }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as lib from './../../lib/lib'
import LazyImage from './../components/common/LazyImage.vue'
import { v4 as uuidv4 } from 'uuid'
import jQuery from 'jquery'

export default {
  components: {
    LazyImage,
  },
  props: {
    idPrefix: {
      required: false,
      type: String,
      default: '',
    },
    yearsOption: {
      required: true,
      type: Number,
    },
    withPrepayment: {
      required: false,
      type: Boolean,
    },
  },
  emits: ['updateYearsOption', 'updateWithPrepayment'],
  data() {
    return {
      key: uuidv4(),
      lang: 'en',
      // data sources
      paymentInAdvanceInteger: '',
      paymentInAdvanceVatIncludedInteger: '',

      saverKmPerYear: null,
      saverGuarantee: '',
      saverGuaranteeTooltip: '',
      saverPriceIncludes: '',

      flexBestValue: false,

      flexKmPerYear: null,
      flexGuarantee: '',
      flexGuaranteeTooltip: '',
      flexPriceIncludes: '',

      programms: null,

      leaseSaverCharacteristics: [],
      leaseFlexCharacteristics: [],

      rentalDuration: '',

      withPrepaymentOwn: true,
      saverVatIncluded: false,
      flexVatIncluded: false,
      yearOption: null,
    }
  },

  computed: {
    saverObject() {
      return this.saverYearsOptions.find((x) => x.years === this.yearsOption)
    },

    flexObject() {
      return this.flexYearsOptions.find((x) => x.years === this.yearsOption)
    },

    saverButtonUrl() {
      const url = this.saverYearsOptions.find(
        (x) => x.years === this.yearsOption
      ).url
      return `${url}&v=${this.yearsOption}&paymentInAdvance=${
        this.withPrepayment ? 1 : 0
      }`
    },

    flexButtonUrl() {
      const url = this.flexYearsOptions.find(
        (x) => x.years === this.yearsOption
      ).url
      return `${url}&v=${this.yearsOption}&paymentInAdvance=${
        this.withPrepayment ? 1 : 0
      }`
    },

    saverIncludesYearsOption() {
      if (this.saverYearsOptions.find((x) => x.years === this.yearsOption)) {
        return true
      }

      return false
    },

    flexIncludesYearsOption() {
      if (this.flexYearsOptions.find((x) => x.years === this.yearsOption)) {
        return true
      }

      return false
    },

    displayPaymentInAdvanceToggle() {
      if (!this.saverObject || !this.flexObject) {
        return false
      }

      return (
        lib.isPositiveNum(
          this.saverObject.priceVatExcludedPaymentInAdvanceExcluded
        ) &&
        lib.isPositiveNum(
          this.flexObject.priceVatExcludedPaymentInAdvanceExcluded
        )
      )
    },

    displaySaverVatToggle() {
      if (!this.saverObject) {
        return false
      }

      if (!this.withPrepaymentOwn) {
        return lib.isPositiveNum(
          this.saverObject.priceVatIncludedPaymentInAdvanceExcluded
        )
      }

      return lib.isPositiveNum(
        this.saverObject.priceVatIncludedPaymentInAdvanceIncluded
      )
    },

    displayFlexVatToggle() {
      if (!this.flexObject) {
        return false
      }

      if (!this.withPrepaymentOwn) {
        return lib.isPositiveNum(
          this.flexObject.priceVatIncludedPaymentInAdvanceExcluded
        )
      }

      return lib.isPositiveNum(
        this.flexObject.priceVatIncludedPaymentInAdvanceIncluded
      )
    },

    programmsYearsOptions() {
      if (!this.saverYearsOptions) {
        return []
      }

      const entry = this.saverYearsOptions.map((x) => {
        return { years: x.years, yearsText: x.yearsText }
      })
      const entry2 = this.flexYearsOptions.map((x) => {
        return { years: x.years, yearsText: x.yearsText }
      })

      const mergedArrays = entry.concat(entry2)

      const options = Array.from(new Set(mergedArrays.map(JSON.stringify))).map(
        JSON.parse
      )

      options.sort((a, b) => a.years - b.years)

      return options
    },

    saverYearsOptions() {
      if (!this.programms) {
        return []
      }
      return this.programms.saver.map((x) => x)
    },

    flexYearsOptions() {
      if (!this.programms) {
        return []
      }
      return this.programms.flex.map((x) => x)
    },

    computedLeaseSaverCharacteristics() {
      return this.leaseSaverCharacteristics.filter((x) => x.title !== '')
    },

    computedLeaseFlexCharacteristics() {
      return this.leaseFlexCharacteristics.filter((x) => x.title !== '')
    },

    calculatedSaverPricePerMonth() {
      if (!this.saverObject) {
        return ''
      }
      if (this.withPrepayment) {
        return `€${this.saverObject.priceVatExcludedPaymentInAdvanceIncluded}`
      }
      return `€${this.saverObject.priceVatExcludedPaymentInAdvanceExcluded}`
    },

    calculatedSaverPricePerMonthIncldVat() {
      if (!this.saverObject) {
        return ''
      }
      if (this.withPrepayment) {
        return `€${this.saverObject.priceVatIncludedPaymentInAdvanceIncluded}`
      }
      return `€${this.saverObject.priceVatIncludedPaymentInAdvanceExcluded}`
    },

    calculatedFlexPricePerMonth() {
      if (!this.flexObject) {
        return ''
      }
      if (this.withPrepayment) {
        return `€${this.flexObject.priceVatExcludedPaymentInAdvanceIncluded}`
      }
      return `€${this.flexObject.priceVatExcludedPaymentInAdvanceExcluded}`
    },

    calculatedFlexPricePerMonthIncldVat() {
      if (!this.flexObject) {
        return ''
      }
      if (this.withPrepayment) {
        return `€${this.flexObject.priceVatIncludedPaymentInAdvanceIncluded}`
      }
      return `€${this.flexObject.priceVatIncludedPaymentInAdvanceExcluded}`
    },
  },

  mounted() {
    const {
      paymentInAdvanceInteger,
      paymentInAdvanceVatIncludedInteger,

      saverKmPerYear,
      saverGuarantee,
      saverGuaranteeTooltip,
      saverPriceIncludes,

      leaseSaverCharacteristics,

      flexBestValue,
      flexKmPerYear,
      flexGuarantee,
      flexGuaranteeTooltip,
      flexPriceIncludes,

      leaseFlexCharacteristics,

      programms,
      rentalDuration,
    } = lib.getData('leasingCarSaverData')

    this.lang = lib.getLocaleFromLangAttr()

    this.paymentInAdvanceInteger = paymentInAdvanceInteger
    this.paymentInAdvanceVatIncludedInteger = paymentInAdvanceVatIncludedInteger
    this.saverKmPerYear = saverKmPerYear
    this.saverGuarantee = saverGuarantee
    this.saverGuaranteeTooltip = saverGuaranteeTooltip
    this.saverPriceIncludes = saverPriceIncludes

    this.leaseSaverCharacteristics = leaseSaverCharacteristics

    this.flexBestValue = flexBestValue
    this.flexKmPerYear = flexKmPerYear
    this.flexGuarantee = flexGuarantee
    this.flexGuaranteeTooltip = flexGuaranteeTooltip
    this.flexPriceIncludes = flexPriceIncludes

    this.leaseFlexCharacteristics = leaseFlexCharacteristics

    this.programms = programms

    this.rentalDuration = rentalDuration

    this.yearOption = this.yearsOption
    this.withPrepaymentOwn = this.withPrepayment

    this.$nextTick(() => {
      lib.iniTooltips(document)
    })
  },
  methods: {
    onChangeWithPrepayment() {
      this.$emit('updateWithPrepayment', this.withPrepaymentOwn)
    },

    onChangeYearOption() {
      this.$emit('updateYearsOption', this.yearOption)
    },

    saverShowMore() {
      const element = this.$refs.saverShowMoreButton
      const element2 = this.$refs.saverShowMoreBody

      jQuery(element).toggleClass('isOpen')
      jQuery(element2).toggleClass('isOpen')
    },
    flexShowMore() {
      const element3 = this.$refs.flexShowMoreButton
      const element4 = this.$refs.flexShowMoreBody

      jQuery(element3).toggleClass('isOpen')
      jQuery(element4).toggleClass('isOpen')
    },

    displayVatToggle(
      priceVatIncludedPaymentInAdvanceIncluded,
      priceVatIncludedPaymentInAdvanceExcluded
    ) {
      if (!this.saverObject) {
        return false
      }

      return (
        lib.isPositiveNum(priceVatIncludedPaymentInAdvanceIncluded) &&
        lib.isPositiveNum(priceVatIncludedPaymentInAdvanceExcluded)
      )
    },
  },
}
</script>
